import Head from "next/head";
import Link from "next/link";

export default function Who() {
	return (
		<>
			<Head>
				<title key="title">Who | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">
					<a href="https://luciensmithstudio.com" rel="noreferrer" target="_blank">
						Who is Lucien Smith?
					</a>
				</h1>
				<div className="text-lg leading-7 mt-5">
					<p>
						Lucien Smith is a multidisciplinary artist. Shortly after earning a degree in Fine Arts from The Cooper Union — his mostly abstract
						paintings earned him international acclaim. Following what seemed like overnight success Smith battled with some of the pitfalls of
						gaining notoriety so early. It was during this period that Smith launched Serving the People a non-profit organization whose mission is to
						provide young artists with opportunity and support.
					</p>
					<p className="mt-6">
						Lobus, an equity management firm focused on artists and collectors, has appointed Smith as the Director of its Cultural Innovation Lab, a
						position that will see him onboard artists onto blockchain technology to manage their assets.
					</p>
				</div>
				<div className="mt-6">
					<Link href="/curiosity">
						<a className="mt-14">Haven&rsquo;t gotten your fill?</a>
					</Link>
				</div>
			</div>
		</>
	);
}
